const loginHome = {
  // 账号注册
  userInfo: `/userApi/v1/Register/uname`,
  // 验证账号是否已存在
  accountTest: `/userApi/v1/Register/accountTest`,
  // 账号登录
  LoginInfo: `/userApi/v1/Login/byPwd`,
  // 手机号登陆，不存在则注册
  judgePhoneLogin: `/userApi/v1/Register/byPhoneLogin`,
  // 手机号注册
  UserPhone: `/userApi/v1/Register/phone`,
  // 绑定手机号
  bindPhone: `/userApi/v1/UserInfo/bindPhone`,
  // 账号名密码登陆 不存在则注册一个
  loginOrReg: `/userApi/v1/Login/loginOrReg`,
  // 账号名密码登陆 不存在则注册一个
  phoneLogin: `/userApi/v1/Login/phoneLogin`,
  // 校验手机号是否存在
  checkPhoneExist: `/userApi/v1/UserInfo/checkPhoneExist`,
  // 解绑手机-校验验证码，并生成修改token
  checkUnbindPhoneCode: `/userApi/v1/UserInfo/checkUnbindPhoneCode`,
  // 解绑手机-根据token解绑手机-极验
  unbindPhoneByToken: `/userApi/v3/UserInfo/UnbindPhoneByToken`,
  // unbindPhoneByToken: `/userApi/v2/UserInfo/UnbindPhoneByToken`,
  // token绑定手机号
  bindPhoneByToken: `/userApi/v1/UserInfo/bindPhoneByToken`,
  // 账号密码注册-带验证码
  registerUname: `/userApi/v1/Register/uname`,
  // 根据用户名查询手机号
  getPhoneByUsername: `/userApi/v1/UserInfo/getPhoneByUsername`,
  // 根据用户名获取手机号前四位
  getPhonePreByUsername: `/userApi/v1/UserInfo/getPhonePreByUsername`,
  // 用户名密码注册
  secondVersoin: `/userApi/v2/Register/uname`,
  // 用户名密码登陆
  loginbypwd: `/userApi/v2/Login/bypwd`,
  // 手机验证码登陆
  // phoneRegister: `/userApi/v2/Login/phoneLogin`,
  // 用户名密码注册接口-带滑块验证
  registerSlider: `/userApi/v2/Register/username`,
  // 用户名密码登陆-带滑块验证
  // bypassword: `/userApi/v2/Login/bypassword`,
  // 手机 验证码登陆2.0
  retypePassword: `/userApi/v2/Login/phoneLogin`,
  // 根据token绑定账号密码
  bindAccountByToken: `/userApi/v1/UserInfo/bindAccountByToken`,
  // 手机验证码登陆 ---- 带滑块验证
  // phoneLoginCaptcha: `/userApi/v2/Login/phoneLoginCaptcha`,
  // 根据账号获取手机验证码
  accountPhoneCode: `/userApi/v1/UserAccount/accountPhoneCode`,
  // 手机验证码登录JAVA
  phoneLoginCaptcha: `/authApi/auth/v1/login/byPhoneCode`,
  // 用户名密码登录JAVA
  bypassword: `/authApi/auth/v1/login/safe/byPwd`
};

export default loginHome;
